<ul [ngClass]="{ 'loading-radial': isRadial, 'loading-inline': !isRadial }" *ngIf="isRadial">
  <li></li>
  <li></li>
  <li></li>
  <li></li>
  <li></li>
</ul>

<ul class="radial-loader" *ngIf="isRadialLoader">
  <li class="radial-loader-line"></li>
</ul>

<div class="main-loader" *ngIf="isMainLoader">
  <ul class="loading-endless">
    <li>
      <span class="first"></span>
      <span class="second"></span>
    </li>
  </ul>

  <div class="main-loader-logo-wrap">
    <div class="main-loader-logo">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="'#' + logoBrand + '-logo-big'"></use>
      </svg>
    </div>
  </div>
</div>

<div class="main-loader main-loader-sending" *ngIf="isSendLoader">
  <div class="main-loader-sending-title">{{ 'Sending' | translate }}</div>
  <ul class="loading-endless">
    <li>
      <span class="first"></span>
      <span class="second"></span>
    </li>
  </ul>
</div>
